import { Notify } from 'quasar'

export const notifyService = {
  success: (message, actions = []) => {
    Notify.create({
      message,
      color: 'brand',
      icon: 'check_circle',
      position: 'bottom-right',
      timeout: 3000,
      actions: [...actions, { icon: 'close', color: 'white', handler: () => {} }],
      progress: true,
    })
  },
  info: (message) => {
    Notify.create({
      message,
      color: 'info',
      icon: 'info',
      position: 'bottom-right',
      timeout: 3000,
      actions: [{ icon: 'close', color: 'white', handler: () => {} }],
      progress: true,
    })
  },
  error: (message, group) => {
    Notify.create({
      ...(group && { group }),
      message,
      color: 'warning',
      icon: 'error',
      position: 'bottom-right',
      timeout: 3000,
      actions: [{ icon: 'close', color: 'white', handler: () => {} }],
      progress: true,
    })
  },
  actions: (message, actions = [], config = {}) => {
    Notify.create({
      group: config.group || 'actions',
      message,
      color: config.color || 'info',
      icon: config.icon || 'notifications',
      position: 'bottom-right',
      timeout: 5000,
      actions: [
        {
          icon: 'close',
          color: 'white',
          handler: () => {},
          dense: true,
        },
        ...actions,
      ],
      progress: true,
    })
  },

  autoRefresh: ({ id, message, onRefresh, onCancel }) => {
    Notify.create({
      group: id,
      message,
      color: 'info',
      icon: 'info',
      position: 'bottom-right',
      timeout: 5000,
      actions: [
        {
          icon: 'close',
          color: 'white',
          handler: onCancel,
          dense: true,
        },
        {
          label: 'Refresh now',
          color: 'white',
          icon: 'refresh',
          dense: true,
          noCaps: true,
          handler: onRefresh,
        },
      ],
      progress: true,
    })
  },

  navigate: ({ id, message, icon, onNavigate }) => {
    Notify.create({
      group: id,
      message,
      color: 'info',
      icon,
      position: 'bottom-right',
      timeout: 5000,
      actions: [
        {
          icon: 'close',
          color: 'white',
          handler: () => {},
          dense: true,
        },
        {
          label: 'View here',
          color: 'white',
          icon: 'visibility',
          dense: true,
          noCaps: true,
          handler: onNavigate,
        },
      ],
      progress: true,
    })
  },
}

export const notifyMsgs = {
  unauthorized: 'You are not authorized to access this page.',
  unauthenticated: 'Please log in to access this page.',
  sessionExpired: 'Your session has expired. Please log in again.',
  logoutSuccess: 'Logged out successfully.',
  logoutError: 'Could not logout. Please try again.',

  error: {
    unknown: 'Something went wrong, please try again.',
    somethingWentWrong: 'Something went wrong. Please try again.',
    createBanner: 'Could not create banner. Please try again.',
    triggerScan: 'Could not start scan. Please try again.',
    triggerScanAlreadyRunning: 'A scan is already in progress for this site.',
    triggerScanInvalidType:
      'Could not start scan due to an invalid request. Please refresh and try again.',
    triggerScanSiteUnavailable:
      'This site is unavailable. It may have been removed or deactivated.',
    overrideScanCategory: 'Could not update tracker category. Please try again.',
    overrideScanCategorySyncFailed:
      'Category saved, but this page could not refresh. Reload to see the change.',
    updateBanner: 'Could not update banner. Please try again.',
    deleteBanner: 'Could not delete banner. Please try again.',
    failedSubmitSupport: 'Failed to submit support request. Please try again.',
    updateAccount: 'Could not update profile. Please try again.',
    setupAccount: 'Could not set up account. Please try again.',
    patchAccount: 'Could not update account. Please try again.',
    renameAccount: 'Could not rename account. Please try again.',
    renameAccountNameTaken: 'That account name is already taken. Please choose another.',
    deleteAccount: 'Could not delete account. Please try again.',
    deleteAccountForbidden: 'Only an admin can delete this account.',
    leaveAccount: 'Could not leave account. Please try again.',
    leaveAccountLastAdmin:
      "You're the only admin on this account. Promote someone else first, or delete the account instead.",
    accountNameTaken: 'That account name is already taken. Please choose another.',
    completeOnboarding: 'Could not finish setting up your account. Please try again.',
    accountAlreadySetUp: 'This account has already been set up.',
    signIn: 'Could not start sign-in. Please try again.',
    updateAccountMemberRole: 'Could not update member role. Please try again.',
    addAccountMember: 'Could not add member. Please try again.',
    addAccountMemberEmailInUseElsewhere: 'This email is already associated with another account.',
    addAccountMemberEmailAlreadyExists: 'This email already exists in your account.',
    removeAccountMember: 'Could not remove member. Please try again.',
    removeAccountMemberUserNotFound: 'Member not found.',
    removeAccountMemberLastAdmin: 'Cannot remove the last admin from your account.',
    removeAccountMemberCannotTargetSelf: 'You cannot remove yourself from the account.',
  },

  success: {
    general: 'Success',
    overrideScanCategory: 'Tracker category updated.',
    updateBanner: 'Banner updated successfully. Changes will take effect shortly.',
    deleteBanner: 'Banner deleted successfully.',
    updateBannerWithScanStarted: (domain) => `Domain updated. Scan started on ${domain}.`,
    supportRequestSubmitted:
      'Your support request has been submitted. We will get back to you soon.',
    updateAccount: 'Profile updated successfully.',
    setupAccount: 'Account set up successfully.',
    patchAccount: 'Account updated successfully.',
    renameAccount: 'Account name updated successfully.',
    updateAccountMemberRole: 'Member role updated.',
    addAccountMember: 'Member added.',
    addAccountMemberResent: (email) => `Invitation resent to ${email}.`,
    removeAccountMember: (email) => `Removed ${email}.`,
  },
}
